import axiox from 'axios';
import connection from './connection';
import { ApplyForLeavesDto, AllApplyForLeavesResponse, ApplyForLeavesResponseModel, ApplyForLeavesReq, GetAllAvailableLeavesDto, GetAllAvailableLeavesResponseModel, ApplyForLeavesModelDtoReq, ApplyForLeavesResponseModels, ApplyForOdCoModelDtoReq, ApplyForOdCoResponseModel, ApplyOdCoFilter } from "@gtpl/shared-models/hrms";
import axios from 'axios';
import { ApplyForLeavesDtos } from 'libs/shared-models/hrms/src/lib/apply-for-leaves/manual-leave.dto';

export class ApplyForLeavesService {

    URL = connection.DEPLOY_URL + '/apply-for-leaves';

    async createLeave(req: ApplyForLeavesModelDtoReq): Promise<ApplyForLeavesResponseModel[]> {
        console.log(req,'req')
        return await axios.post(this.URL + '/createLeave', req)
            .then(res => {
                return res.data;
            })
    }

    async createManualLeave(req: ApplyForLeavesDtos): Promise<ApplyForLeavesResponseModels> {
        console.log(req,'req')
        return await axios.post(this.URL + '/createManualLeave', req)
            .then(res => {
                return res.data;
            })
    }

    async updateLeave(dto: ApplyForLeavesDto): Promise<ApplyForLeavesResponseModel> {
        return await axios.post(this.URL + '/updateLeave', dto)
            .then(res => {
                return res.data;
            })
    }

    async getAllAppliedLeaves(): Promise<AllApplyForLeavesResponse> {
        return await axios.post(this.URL + '/getAllAppliedLeaves')
            .then(res => {
                return res.data;
            })
    }



    async activateOrDeactivateApplyForLeave(dto: ApplyForLeavesReq): Promise<ApplyForLeavesResponseModel> {
        return await axios.post(this.URL + '/activateOrDeactivateApplyForLeave', dto)
            .then(res => {
                return res.data;
            })
    }

    async getApplyForLeavesById(req: ApplyForLeavesReq): Promise<ApplyForLeavesResponseModel> {
        return await axios.post(this.URL + '/getApplyForLeavesById', req)
            .then(res => {
                return res.data;
            })
    }
    
    async updateLeaveStatus(req: ApplyForLeavesReq): Promise<ApplyForLeavesResponseModel> {
        return await axios.post(this.URL + '/updateLeaveStatus', req)
            .then(res => {
                return res.data;
            })
    }

    async getAllAvailableLeaves(req: GetAllAvailableLeavesDto): Promise<GetAllAvailableLeavesResponseModel> {
        return await axios.post(this.URL + '/getAllAvailableLeaves', req)
            .then(res => {
                return res.data;
            })
    }




    async createOdCo(req: ApplyForOdCoModelDtoReq): Promise<ApplyForOdCoResponseModel[]> {
        console.log(req,'req')
        return await axios.post(this.URL + '/createOdCo', req)
            .then(res => {
                return res.data;
            })
    }


    async getCoOd(typeReq:ApplyOdCoFilter): Promise<ApplyForOdCoResponseModel> {
        return await axios.post(this.URL + "/getCoOd",typeReq)
        .then(res => {
            return res.data
          })
    }
}